import React, { useEffect, useMemo, useRef } from 'react';
import { Container, Graphics, Sprite } from '@pixi/react';
// import { Graphics } from 'pixi.js';
import { observer } from 'mobx-react-lite';

import { connectionPopupStore } from '../../../store/connectionPopupStore';

import { isMobile } from '../../../core/helpers/isMobile';
import { PopupTypes } from '../../../core/constants/popupTypes';
import { getGameImages } from '../../../core/helpers/getGameImages';

import ReconnectPopup from '../../../components/web/reconnect';
import SessionExpired from '../../../components/web/sessionExpired';
import ScaleComponent from '../../../components/mobile/scaleComponent';
import InsufficientAmount from '../../../components/web/insufficientAmount';

const ConnectionPopup = observer(({ x, y }) => {
  const { popupName, isOpenPopup } = connectionPopupStore;
  const containerRef = useRef();
  const { reconnectInfoBackground } = useMemo(() => {
    return getGameImages();
  }, []);

  const popupComponents = useMemo(() => {
    return {
      [PopupTypes.RECONNECT_POPUP]: ReconnectPopup,
      [PopupTypes.SESSION_EXPIRED]: SessionExpired,
      [PopupTypes.INSUFFICIENT_AMOUNT]: InsufficientAmount,
    };
  }, []);

  const PopupComponent = useMemo(() => {
    return popupComponents[popupName];
  }, [popupName, popupComponents]);

  useEffect(() => {
    if (containerRef.current && !isMobile()) {
      const graphics = new Graphics();
      graphics.beginFill('black');
      graphics.alpha = 0.7;
      graphics.drawRect(0, 0, isMobile() ? 600 : 1440, isMobile() ? 960 : 810);
      containerRef.current.addChildAt(graphics, 0);
    }
  }, [popupName]);

  if (!isOpenPopup) {
    return null;
  }
  return (
    <>
      <Graphics
        draw={(g) => {
          g.clear();
          g.beginFill('black');
          g.drawRect(
            0,
            0,
            isMobile() ? window.innerWidth : 1440,
            isMobile() ? window.innerHeight : 860
          );
          g.alpha = 0.8;
          g.interactive = true;
        }}
      />
      <ScaleComponent name='ConnectionPopupWrapper' isCenterHorizontal isCenterVertical>
        <Container x={x} y={y}>
          <Sprite texture={reconnectInfoBackground} />
          {PopupComponent && <PopupComponent />}
        </Container>
      </ScaleComponent>
    </>
  );
});
export default ConnectionPopup;
